var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRfqGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1V3C7 3.26522 7.10536 3.51957 7.29289 3.70711C7.48043 3.89464 7.73478 4 8 4H10M8 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V3.5L7.5 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73478 2 2V3.75M2.00847 5.75598C1.70266 6.02737 1.45555 6.35842 1.28232 6.72878C1.10909 7.09914 1.01339 7.501 1.00111 7.90969C0.988827 8.31838 1.06021 8.72526 1.21089 9.10536C1.36156 9.48545 1.58835 9.83074 1.87731 10.12C2.16627 10.4093 2.51132 10.6364 2.89125 10.7875C3.27119 10.9386 3.678 11.0104 4.0867 10.9986C4.4954 10.9867 4.89736 10.8914 5.26791 10.7186C5.63845 10.5458 5.96976 10.299 6.24147 9.99348M4.5 7.99996C4.36739 7.99996 4.24021 7.94728 4.14645 7.85351C4.05268 7.75974 4 7.63257 4 7.49996V5.49996C4 5.22396 4.225 4.99596 4.4975 5.04146C5.11265 5.1449 5.68027 5.43752 6.12135 5.8786C6.56244 6.31969 6.85506 6.8873 6.9585 7.50246C7.004 7.77446 6.776 7.99996 6.5 7.99996H4.5Z",
    stroke: "#525062",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqGrey);
export default __webpack_public_path__ + "static/media/rfqGrey.cb51cea4226f486f1c82a1304103b9cc.svg";
export { ForwardRef as ReactComponent };